import React from "react";
import { OrganizationRegionalCard } from "./OrganizationRegionalCard";
import { OrganizationRegionalUIProvider } from "./OrganizationRegionalUIContext";

export function OrganizationRegionalPage({ history, match }) {
  const organizationRegionalUIEvents = {
    newOrganizationRegionalButtonClick: () => {
      history.push("/admin/master-data/regional/create");
    },
    openEditOrganizationRegionalPage: id => {
      history.push(`/admin/master-data/regional/${id}/edit`);
    }
  };

  return (
    <OrganizationRegionalUIProvider
      organizationRegionalUIEvents={organizationRegionalUIEvents}
    >
      <OrganizationRegionalCard history={history} match={match} />
    </OrganizationRegionalUIProvider>
  );
}
